import { render, staticRenderFns } from "./MyChattings.vue?vue&type=template&id=0d58371f&scoped=true&"
import script from "./MyChattings.vue?vue&type=script&lang=js&"
export * from "./MyChattings.vue?vue&type=script&lang=js&"
import style0 from "./MyChattings.vue?vue&type=style&index=0&id=0d58371f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d58371f",
  null
  
)

export default component.exports